import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import AppointmentWithContactInfoSection from '../Section/AppointmentWithContactInfoSection';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';
import a20 from "../Images/a20.webp";
import a5 from "../Images/a5.png";
import contactbg101 from "../Images/bg/contactbg101.jpg"



export default function Appointments() {
  pageTitle('Appointments');
  return (
    <>
      <BannerSectionStyle3
        bgUrl={contactbg101}
        // imgUrl={a5}
        title="Don’t Let Your Hospital Take a Backseat!"
        subTitle="Fill  the demo form below to schedule a demo with one of our professionals 
        to know about our product."
      />
      <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <AppointmentWithContactInfoSection />
      </Section>
    </>
  );
}
